// Navegación completa (recarga): descarta todo el estado de React. Aislada en
// un módulo para poder mockearla en los tests.
export const hardNavigate = path => {
  window.location.assign(path);
};
